|
<template>
  <div>
    <menu-content-container :padding-left-right="8">
      <FontSizeColor
        :data-testid="`product-${typeName}-text-settings`"
        :block-name="typeName"
        no-border
        :prodstructure="prodstructure"
      />
    </menu-content-container>

    <menu-content-container
      :header="$t('forms.image_align')"
      :padding-left-right="8"
    >
      <TButtonGroup style="margin-top: 12px">
        <TGroupButton
          data="left"
          :data-testid="`${typeName}-align-left`"
          small
          :active="align === 'left'"
          @button-clicked="() => (align = 'left')"
        >
          <AligmentLeft />
        </TGroupButton>
        <TGroupButton
          data="center"
          :data-testid="`${typeName}-align-center`"
          small
          :active="align === 'center'"
          @button-clicked="() => (align = 'center')"
        >
          <AligmentCenter />
        </TGroupButton>
        <TGroupButton
          data="right"
          :data-testid="`${typeName}-align-right`"
          small
          :active="align === 'right'"
          @button-clicked="() => (align = 'right')"
        >
          <AligmentRight />
        </TGroupButton>
      </TButtonGroup>
    </menu-content-container>

    <eurToggler
      v-if="typeName.includes('price')"
      :selected-item="selectedItem"
      :block="block"
      :layout="layout"
    ></eurToggler>

    <paddingForm
      :data-testid="`${typeName}-margin-form`"
      :product="true"
      :prodstructure="prodstructure"
      :padding-left-right="8"
      class="!mb-2"
      :border-bottom="false"
      :prefix="`${typeName}-`"
    ></paddingForm>
  </div>
</template>

<script lang="ts" setup>
  import paddingForm from "../paddingForm.vue";
  import FontSizeColor from "./fontSizeColorProduct.vue";
  import eurToggler from "./eurToggler.vue";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { AligmentCenter, AligmentLeft, AligmentRight } from "@topol/icons";
  import { TButtonGroup, TGroupButton } from "@topol/twig-ui";
  import { computed, onMounted } from "vue";

  const mjmlStore = useMjmlStore();
  const props = defineProps<{
    name: string;
    selectedItem: any;
    block: any;
    layout: {
      type: any;
      displayed: any;
      uid: string;
    }[];
  }>();

  const typeName = computed(() => {
    if (props.name === "priceBefore") {
      return "price-before";
    }
    if (props.name === "publishedat") {
      return "published-at";
    }
    if (props.name === "publishedby") {
      return "published-by";
    }
    return props.name;
  });

  const prodstructure = computed(() => {
    const prodstructure = mjmlStore.getActiveBlockAttrString("prodstructure");
    if (prodstructure) {
      return prodstructure;
    }
    return false;
  });

  const align = computed({
    get() {
      return mjmlStore.getActiveBlockAttrString(`${typeName.value}-align`);
    },
    set(val: string) {
      mjmlStore.updateBlockAttribute({
        prop: `${typeName.value}-align`,
        value: val,
        product: true,
        prodstructure: prodstructure.value,
      });
    },
  });

  onMounted(() => {
    if (mjmlStore.getActiveBlockAttrString(`${typeName.value}-align`) == null) {
      align.value = "center";
    }
  });
</script>
